module.exports = __webpack_public_path__ + "img/SKWINKELNetActieDraaiboekA1BD39.a13f0ed6.png";